import { createSelector } from 'reselect';
import { selectCommonBrandVersion } from 'selectors/brandSelector';

export const selectPlayerData = (state) => state.playerData;

export const selectPlayerCurrencyId = (state) => selectPlayerData(state).currencyId;
export const selectPlayerCountryId = (state) => selectPlayerData(state).countryId;

export const selectPlayerAccountBalance = (state) => state.accountBalance;

export const selectPlayerLoading = (state) => state.loading;
export const selectPlayerReportLoading = (state) => state.reportLoading;

const selectPlayerNote = (state) => state.note;
export const selectPlayerNoteData = (state) => selectPlayerNote(state).data;
export const selectPlayerNoteTotal = (state) => selectPlayerNote(state).total;
export const selectPlayerNoteTypes = (state) => selectPlayerNote(state).types;
export const selectPlayerNotesLoading = (state) => state.notesLoading;

export const selectPlayerModalVisible = (state) => state.modalVisible;
export const selectPlayerModalLoadingState = (state) => state.modalLoading;
export const selectPlayerMessages = (state) => state.messages;
export const selectPlayerMessage = (state) => state.message;
export const selectPlayerMessagesTotal = (state) => state.messagesTotal;
export const selectPlayerEndedStatus = (state) => state.endedStatus;
export const selectPlayerControls = (state) => state.controls;

const selectPlayerRGSettings = (state) => state.responsibleGamingSettings;
export const selectPlayerTimeoutSettings = (state) => selectPlayerRGSettings(state).timeout;
export const selectPlayerDepositSettings = (state) => selectPlayerRGSettings(state).deposit;
export const selectPlayerNetDepositSettings = (state) => selectPlayerRGSettings(state).netDeposit;
export const selectPlayerWithdrawalSettings = (state) => selectPlayerRGSettings(state).withdrawal;
export const selectPlayerBetSettings = (state) => selectPlayerRGSettings(state).bet;
export const selectPlayerRealityCheckSettings = (state) => selectPlayerRGSettings(state).realityCheck;
export const selectPlayerAccessLimitSettings = (state) => selectPlayerRGSettings(state).accessLimit;
export const selectPlayerAccessLimitPendingSettings = (state) => selectPlayerRGSettings(state).accessLimitPending;
export const selectPlayerAccessLimitOverviewSettings = (state) => selectPlayerRGSettings(state).accessLimitOverview;
export const selectPlayerAccessLimitSettingsLog = (state) => selectPlayerRGSettings(state).accessLimitLog;

const selectPlayerRGLogs = (state) => selectPlayerRGSettings(state).logs;
export const selectPlayerRGLogsData = (state) => selectPlayerRGLogs(state).data;
export const selectPlayerRGLogsTotal = (state) => selectPlayerRGLogs(state).total;

const selectPlayerActions = (state) => state.actions;
export const selectPlayerActionsData = (state) => selectPlayerActions(state).data;
export const selectPlayerActionsTotal = (state) => selectPlayerActions(state).total;

export const selectPlayerDataChanged = (state) => state.isPlayerDataChanged;
export const selectPlayerBrandId = (state) => selectPlayerData(state).brandId;
const selectPlayerReminderLimits = (state) => selectPlayerRGSettings(state).reminderLimits;
export const selectPlayerBetLimit = (state) => selectPlayerReminderLimits(state).betLimit;
export const selectPlayerDepositLimit = (state) => selectPlayerReminderLimits(state).depositLimit;
export const selectPlayerNetDepositLimit = (state) => selectPlayerReminderLimits(state).netDepositLimit;
export const selectPlayerWithdrawalLimit = (state) => selectPlayerReminderLimits(state).withdrawalLimit;
export const selectPlayerLossLimit = (state) => selectPlayerReminderLimits(state).lossLimit;
export const selectPlayerGameTimeLimit = (state) => selectPlayerReminderLimits(state).timeLimit;
export const selectPlayerPersonalInfo = (state) => state.personalInfo;
export const selectPlayerAccountInfo = (state) => state.accountInfo;
export const selectPlayerIsDeleted = createSelector(selectPlayerData, (data) => data.isDeleted);
export const selectPlayerBlockedPaymentMethods = (state) => selectPlayerAccountInfo(state).blockedPaymentMethods;
export const selectPlayerAccountBlockedProviders = (state) => selectPlayerAccountInfo(state).blockedProviders;

export const selectPlayerAccountInfoChanged = (state) => state.isPlayerAccountInfoChanged;
export const selectPlayerPersonalInfoChanged = (state) => state.isPlayerPersonalInfoChanged;
export const selectPlayerActionEndedStatus = (state) => state.playerActionEndedStatus;

export const selectPlayerLimitsLoading = (state) => state.playerLimitsLoading;

export const selectPlayerLimitLoading = (state, id) => createSelector(
  () => selectPlayerLimitsLoading(state),
  (data) => !!data[id],
)();

export const selectPlayerLossLimitSettings = (state) => selectPlayerRGSettings(state).lossLimit;
export const selectPlayerSingleBetSettings = (state) => selectPlayerRGSettings(state).singleBet;
export const selectPlayerGameTimeLimitSettings = (state) => selectPlayerRGSettings(state).gameTimeLimit;
export const selectHasPlayerTransaction = (state) => state.hasTransaction;
export const selectHasPlayerTransactionLoading = (state) => state.hasTransactionLoading;

export const selectPlayerVerified = (state) => selectPlayerData(state).isAccountVerified;

export const selectPlayerLegacyData = (state) => state.playerLegacyData;

export const selectPlayerBrandVersion = selectCommonBrandVersion((state) => selectPlayerBrandId(state.player));

export const selectPlayerOTP = (state) => state.playerOTP;

export const selectPlayerDataForAttachment = (state) => {
  const player = selectPlayerData(state);
  if (!player) return null;

  return {
    firstName: player.firstName,
    lastName: player.lastName,
    birthDate: player.birthDate,
    address: player.address,
  };
};

export const selectEpisPlayerState = (state) => selectPlayerData(state).episPlayerState;
